import { QueryObserverResult, useQuery } from 'react-query';
import { AxiosError } from 'axios';

import { getCountries } from '../api/countries';
import { BaseQueryParams } from '../common/models/base-query-params';
import { CountryResponse } from '../common/models/country';
import { HttpException } from '../common/models/httpException';
import { Paginated } from '../common/models/paginated';
import { ALL_PAGINATED_LIST_ITEMS_PARAMS } from '../common/utils/common';

export const CK_COUNTRIES = 'countries';

export const useCountries = (
  params: BaseQueryParams = ALL_PAGINATED_LIST_ITEMS_PARAMS,
): QueryObserverResult<Paginated<CountryResponse>, AxiosError<HttpException>> =>
  useQuery([CK_COUNTRIES, { text: params.q, page: params.page, limit: params.limit }], () => getCountries(params));
